import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class HsmSubnetPoolService extends Service {
    constructor() {
        super();
        this.baseURL = 'hsmSubnetPool';
    }
    
    findByOrganizationId(organizationId, data) {
        return fetch(SERVER_URL + this.baseURL + '/findByOrganizationId/' + organizationId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            crossDomain: true,
            method: 'post',
            body: JSON.stringify(data)
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}